export default "__VITE_ASSET__Cj_yJrTX__"